"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const testimonial_360_webp_1 = __importDefault(require("../../../assets/images/testimonial-360.webp"));
const testimonial_airbnb_webp_1 = __importDefault(require("../../../assets/images/testimonial-airbnb.webp"));
const testimonial_google_webp_1 = __importDefault(require("../../../assets/images/testimonial-google.webp"));
const testimonialsContent = [
    {
        id: 1,
        description: 'Quanto capricho e cuidado em cada detalhe, tudo que eu precisei para minha estadia',
        witnessImage: testimonial_360_webp_1.default,
        witnessName: 'Nany Guimas',
    },
    {
        id: 2,
        description: 'Lugar sensacional, segurança total, perto de todos lugares de sp, super confortável!',
        witnessImage: testimonial_airbnb_webp_1.default,
        witnessName: 'Camila Loures',
    },
    {
        id: 3,
        description: '360 além do atendimento, o ambiente é super agradável, amo ficar nos Apt, sempre estou indicando, e o os valores e menor do que o Tokinho, cabe no bolso em rsrs 😉♥',
        witnessImage: testimonial_google_webp_1.default,
        witnessName: 'Tokinho',
    },
];
exports.default = testimonialsContent;
